import moment from "moment"

export class TimeUtils {
  static showDateTime = (time: moment.MomentInput) => {
    if (!time) return '---'

    return moment(time).format("HH:mm DD/MM/YYYY")
  }
}
